// PT UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Apartamentos e hotéis',
  'site.currency': 'Moeda',
  'site.language': 'Idioma',
  'site.currencySelector': 'Seletor de moeda',
  'site.languageSelector': 'Seletor de idioma',
  'site.menu': 'Menu',
  'site.signIn': 'Iniciar sessão',
  'site.signOut': 'Terminar sessão',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Abrir menu',
  'site.footer.copyright': 'Todos os direitos reservados.',
  'site.footer.manageBooking': 'Gerir a sua reserva',
  'site.footer.terms': 'Termos e Condições',
  'site.footer.privacy': 'Política de Privacidade',
  'site.trust.bestPrice': 'Garantia do melhor preço',
  'site.trust.bestPriceDesc': 'Obtenha as melhores tarifas.',
  'site.trust.flexibleBooking': 'Reserva flexível',
  'site.trust.flexibleBookingDesc': 'Alterações e cancelamentos fáceis.',
  'site.trust.securePayments': 'Pagamentos seguros',
  'site.trust.securePaymentsDesc': 'Checkout seguro e de confiança.',
  'site.trust.localSupport': 'Apoio local',
  'site.trust.localSupportDesc': 'Estamos aqui para ajudar a qualquer hora.',
  'home.heroTitle': 'Encontre a sua estadia perfeita',
  'home.inAustralia': 'na Austrália',
  'home.heroSubtitle': 'Apartamentos e hotéis para todo o tipo de estadia',
  'home.errorLoading': 'Não foi possível carregar as propriedades.',
  'home.noPropertiesTitle': 'De momento não há propriedades disponíveis.',
  'home.noPropertiesDescription': 'Tente procurar um destino para explorar estadias disponíveis.',
  'home.exploreStays': 'Explorar estadias',
  'home.property': 'propriedade',
  'home.property_one': 'propriedade',
  'home.property_other': 'propriedades',
  'home.properties': 'propriedades',
  'home.foundInAustralia': 'encontradas na Austrália',
  'search.errorLoading': 'Não foi possível carregar a disponibilidade. Por favor, tente novamente.',
  'search.noResults': 'Nenhuma propriedade corresponde aos critérios de pesquisa.',
  'search.mapFollow': 'Pesquisar ao mover o mapa',
  'search.chooseLocationTitle': 'Escolha uma localização',
  'search.chooseLocationDescription':
    'Selecione um destino antes de pesquisar estadias disponíveis.',
  'search.chooseDatesTitle': 'Escolha as datas',
  'search.pastCheckIn': 'O check-in não pode ser no passado.',
  'search.checkOutAfterCheckIn': 'O check-out tem de ser depois do check-in.',
  'search.property': 'propriedade',
  'search.property_one': 'propriedade',
  'search.property_other': 'propriedades',
  'search.properties': 'propriedades',
  'search.found': 'encontradas',
  'widget.where': 'Onde',
  'widget.location': 'Localização',
  'widget.checkInOut': 'Check-in / Check-out',
  'widget.guests': 'Hóspedes',
  'widget.rooms': 'Quartos',
  'widget.promoCode': 'Código promocional',
  'widget.promoPlaceholderCompact': 'Adicionar código (opcional)',
  'widget.promoPlaceholder': 'Opcional',
  'widget.search': 'Pesquisar',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'Adulto',
  'widget.adults': 'Adultos',
  'widget.child': 'Criança',
  'widget.children': 'Crianças',
  'widget.decreaseAdults': 'Diminuir adultos',
  'widget.increaseAdults': 'Aumentar adultos',
  'widget.decreaseChildren': 'Diminuir crianças',
  'widget.increaseChildren': 'Aumentar crianças',
  'widget.room': 'Quarto',
  'widget.adultOption': '{count} Adultos',
  'widget.adultOption_one': '{count} Adulto',
  'widget.adultOption_other': '{count} Adultos',
  'widget.childOption': '{count} Crianças',
  'widget.childOption_one': '{count} Criança',
  'widget.childOption_other': '{count} Crianças',
  'widget.roomOption': '{count} Quartos',
  'widget.roomOption_one': '{count} Quarto',
  'widget.roomOption_other': '{count} Quartos',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'Não foi possível carregar as localizações. Por favor, tente novamente.',
  'widget.searchAria': 'Pesquisar disponibilidade',
  'widget.dateErrorRequired': 'Por favor, selecione as datas de check-in e check-out.',
  'widget.dateErrorPast': 'O check-in não pode ser no passado.',
  'widget.dateErrorRange': 'O check-out tem de ser depois do check-in.',
  'widget.dateRange.placeholder': 'Selecione as datas de check-in e check-out',
  'widget.dateRange.selectCheckout': 'Selecione o check-out',
  'widget.dateRange.aria.checkIn': 'Check-in',
  'widget.dateRange.aria.checkOut': 'Check-out',
  'widget.dateRange.aria.picker': 'Seletor de intervalo de datas de check-in / check-out',
  'widget.dateRange.previousMonth': 'Mês anterior',
  'widget.dateRange.nextMonth': 'Mês seguinte',
  'widget.dateRange.selectCheckIn': 'Selecione a data de check-in',
  'widget.dateRange.selectCheckOut': 'Selecione a data de check-out',
  'widget.dateRange.resetToday': 'Repor para hoje',
  'widget.dateRange.done': 'Concluído',
  'property.heroAlt': 'Imagem principal da propriedade',
  'property.fallbackName': 'Propriedade selecionada por {site}',
  'property.chooseRoom': 'Escolha o seu quarto',
  'property.filterBy': 'Filtrar por:',
  'property.filterAll': 'Todos os quartos',
  'property.filterStudios': 'Estúdios',
  'property.filter1Bed': '1 quarto',
  'property.filter2Bed': '2 quartos',
  'property.filterApartments': 'Apartamentos',
  'property.sortBy': 'Ordenar por:',
  'property.sortRecommended': 'Recomendado',
  'property.sortPriceLow': 'Preço: baixo para alto',
  'property.sortPriceHigh': 'Preço: alto para baixo',
  'property.errorLoading':
    'Não foi possível carregar a disponibilidade. Por favor, tente novamente.',
  'property.noRooms': 'Não há quartos disponíveis',
  'property.noRoomsDescription': 'Tente outras datas ou ocupação.',
  'property.totalForNights': 'Total por {nights} noites',
  'property.perNight': 'por noite',
  'property.night': 'noite',
  'property.night_one': 'noite',
  'property.night_other': 'noites',
  'property.nights': 'noites',
  'property.freeCancellation': 'Cancelamento gratuito',
  'property.selectRoom': 'Selecionar quarto',
  'property.selected': 'Selecionado',
  'property.continue': 'Continuar',
  'property.previousPhoto': 'Foto anterior',
  'property.nextPhoto': 'Foto seguinte',
  'property.addToWishlist': 'Adicionar à lista de desejos',
  'property.popularChoice': 'Escolha popular',
  'property.showMore': 'Mostrar mais',
  'property.showLess': 'Mostrar menos',
  'property.maxOccupancy': 'Ocupação máxima:',
  'property.size': 'Tamanho:',
  'property.bedType': 'Tipo de cama:',
  'property.roomAmenities': 'Comodidades do quarto',
  'property.showMoreAmenities': '+{count} mais',
  'property.guests': 'Hóspedes',
  'property.adults': 'Adultos',
  'property.children': 'Crianças',
  'property.onlyRoomsLeft': 'Restam apenas {count} quartos',
  'property.onlyRoomsLeft_one': 'Resta apenas {count} quarto',
  'property.onlyRoomsLeft_other': 'Restam apenas {count} quartos',
  'property.lastBookedMinutes': 'Última reserva há {count} minutos',
  'property.lastBookedMinutes_one': 'Última reserva há {count} minuto',
  'property.lastBookedMinutes_other': 'Última reserva há {count} minutos',
  'property.lastBookedHours': 'Última reserva há {count} horas',
  'property.lastBookedHours_one': 'Última reserva há {count} hora',
  'property.lastBookedHours_other': 'Última reserva há {count} horas',
  'property.lastBookedDays': 'Última reserva há {count} dias',
  'property.lastBookedDays_one': 'Última reserva há {count} dia',
  'property.lastBookedDays_other': 'Última reserva há {count} dias',
  'property.checkInTime': 'Check-in {time}',
  'property.checkOutTime': 'Check-out {time}',
  'property.compare': 'Comparar',
  'property.taxesIncluded': 'por noite, incluindo impostos e taxas',
  'property.chooseRate': 'Escolha a sua tarifa',
  'property.yourSelection': 'A sua seleção',
  'property.aboutRoom': 'Sobre este quarto',
  'property.roomDetails': 'Detalhes do quarto',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Voltar aos quartos',
  'property.standardRate': 'Tarifa padrão',
  'property.noPromotion': 'Nenhuma promoção disponível para esta tarifa.',
  'property.youSave': 'Poupa ({percent}% de desconto) - {amount}',
  'property.inclusions': 'Inclui:',
  'property.viewAllPhotos': 'Ver todas as fotos',
  'property.seeOnMap': 'Ver no mapa',
  'room.perNight': 'noite',
  'room.sleeps': 'Acomoda',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'disponível',
  'room.select': 'Selecionar',
  'room.selected': 'Selecionado',
  'card.viewAvailability': 'Ver disponibilidade',
  'card.from': 'A partir de',
  'card.night': 'noite',
  'card.checkAvailability': 'Verificar disponibilidade',
  'card.saveToFavourites': 'Guardar nos favoritos',
  'card.ratingExcellent': 'Excelente',
  'card.ratingVeryGood': 'Muito bom',
  'card.ratingGood': 'Bom',
  'card.ratingGuest': 'Avaliação dos hóspedes',
  'guest.stepChooseRoom': 'Escolher quarto',
  'guest.stepGuestDetails': 'Dados do hóspede',
  'guest.stepPayment': 'Pagamento',
  'guest.stepConfirmation': 'Confirmação',
  'guest.title': 'Introduza os dados do hóspede',
  'guest.subtitle': 'Por favor, forneça os seus dados.',
  'guest.firstName': 'Primeiro nome',
  'guest.lastName': 'Apelido',
  'guest.email': 'E-mail',
  'guest.emailHint': 'A confirmação da reserva será enviada para este e-mail.',
  'guest.country': 'País',
  'guest.selectCountry': 'Selecione o país',
  'guest.searchCountry': 'Pesquisar países…',
  'guest.loadingCountries': 'A carregar países…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Código postal',
  'guest.phone': 'Número de telefone',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Introduza o número de telefone',
  'guest.address': 'Morada',
  'guest.city': 'Cidade',
  'guest.specialRequests': 'Pedidos especiais (opcional)',
  'guest.specialRequestsPlaceholder': 'Algum pedido especial?',
  'guest.termsPrefix': 'Ao concluir esta reserva, concordo com os',
  'guest.terms': 'Termos e Condições',
  'guest.termsAnd': 'e',
  'guest.privacy': 'Política de Privacidade',
  'guest.termsSuffix': ', e aceito as condições da reserva.',
  'guest.marketingOptOut': 'Não quero receber mensagens de marketing.',
  'guest.cardVerify':
    'Será efetuada uma verificação temporária de 1 {currency} no cartão. Não será cobrado agora.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'O pagamento será efetuado na propriedade.',
  'guest.noRoomsSelected': 'Nenhum quarto selecionado.',
  'guest.noPropertySelected': 'Nenhuma propriedade selecionada.',
  'guest.paymentStillLoading':
    'As opções de pagamento ainda estão a carregar. Por favor, tente novamente dentro de momentos.',
  'guest.submitProcessing': 'A processar…',
  'guest.submitVerifyCard': 'Verificar cartão e confirmar reserva',
  'guest.submitConfirm': 'Confirmar reserva',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Pagamento',
  'payment.method': 'Método de pagamento',
  'payment.cardDetailsHint':
    'Introduza os dados do seu cartão em segurança abaixo. Os dados do cartão são tokenizados e nunca chegam aos nossos servidores.',
  'payment.loadingForm': 'A carregar formulário de pagamento…',
  'payment.formUnavailable': 'Formulário de pagamento indisponível.',
  'payment.acceptTerms': 'Aceito os termos e condições e a política de cancelamento.',
  'payment.payNow': 'Pagar agora',
  'payment.processing': 'A processar…',
  'payment.noRoomsSelected': 'Nenhum quarto selecionado.',
  'payment.redirecting': 'A redirecionar para a página de pagamento segura…',
  'payment.notConfigured': 'O Quickstream não está configurado para esta propriedade.',
  'payment.noScript':
    'O serviço de pagamento Quickstream não pôde ser carregado. Por favor, atualize a página.',
  'payment.formNotLoaded': 'Formulário de pagamento não carregado. Por favor, atualize a página.',
  'payment.cardDetails': 'O pagamento falhou. Por favor, verifique os dados do cartão.',
  'payment.tokenizationFailed': 'A tokenização do cartão falhou. Por favor, tente novamente.',
  'payment.failed': 'O pagamento falhou.',
  'payment.statusResult': 'Estado do pagamento: {status}. Por favor, tente novamente.',
  'confirmation.loading': 'A carregar a sua reserva…',
  'confirmation.notFound':
    'Reserva não encontrada. Verifique a referência da reserva e tente novamente.',
  'confirmation.errorGeneric':
    'A sua reserva não pôde ser confirmada. Por favor, contacte o apoio.',
  'confirmation.errorLoadDetails': 'Não foi possível carregar os detalhes da reserva.',
  'confirmation.couldNotComplete': 'Não conseguimos concluir o seu pagamento',
  'confirmation.startNew': 'Iniciar uma nova reserva',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound':
    'Sessão de pagamento não encontrada. Por favor, contacte o apoio.',
  'confirmation.paymentStateInvalid':
    'O pagamento não se encontra num estado válido para concluir. Por favor, comece de novo.',
  'confirmation.paymentFailedDeclined':
    'O seu pagamento não pôde ser concluído. Por favor, verifique os dados do cartão e tente novamente, ou utilize outro método de pagamento.',
  'confirmation.paymentTimeout': 'O pagamento demorou demasiado tempo. Por favor, tente novamente.',
  'confirmation.paymentGatewayUnavailable':
    'O sistema de pagamento está temporariamente indisponível. Por favor, tente novamente dentro de momentos.',
  'confirmation.paymentUnknown': 'O pagamento não pôde ser confirmado: {message}.',
  'confirmation.paymentGenericError':
    'O pagamento não pôde ser confirmado. Por favor, tente novamente ou contacte o apoio.',
  'summary.title': 'Resumo da sua reserva',
  'summary.yourBooking': 'Resumo da sua reserva',
  'summary.noRoomsSelected': 'Ainda não selecionou nenhum quarto.',
  'summary.checkIn': 'CHECK-IN',
  'summary.checkOut': 'CHECK-OUT',
  'summary.lengthOfStay': 'Duração da estadia',
  'summary.guests': 'Hóspedes',
  'summary.nights': '{nights} noites',
  'summary.nights_one': '{nights} noite',
  'summary.nights_other': '{nights} noites',
  'summary.totalForNights': 'Total por {nights} noites',
  'summary.includingTaxes': 'Incluindo impostos e taxas',
  'summary.discount': 'Poupe {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'Reserva confirmada!',
  'detail.received': 'Reserva recebida',
  'detail.referenceIntro': 'A referência da sua reserva é',
  'detail.reservationId': 'ID da reserva:',
  'detail.processing':
    'A sua reserva está a ser processada. Receberá um e-mail de confirmação assim que o pagamento for confirmado.',
  'detail.guest': 'Hóspede',
  'detail.rooms': 'Quartos',
  'detail.night': 'noite',
  'detail.nights': 'noites',
  'detail.adult': 'adulto',
  'detail.adults': 'adultos',
  'detail.child': 'criança',
  'detail.infant': 'bebé',
  'detail.priceBreakdown': 'Detalhamento do preço',
  'detail.subtotal': 'Subtotal',
  'detail.taxes': 'Impostos',
  'detail.fees': 'Taxas',
  'detail.discounts': 'Descontos',
  'detail.surcharge': 'Sobretaxa do cartão',
  'detail.grandTotal': 'Total geral',
  'priceBreakdown.roomSubtotal': 'Subtotal do quarto',
  'priceBreakdown.total': 'Total',
  'detail.deposit': 'Depósito',
  'detail.depositDueBy': 'a pagar até',
  'detail.arrival': 'chegada',
  'detail.specialRequests': 'Pedidos especiais',
  'detail.backToHome': 'Voltar ao início',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Tentar novamente',
  'shared.close': 'Fechar',
  'shared.back': 'Voltar',
  'shared.previous': 'Anterior',
  'shared.next': 'Seguinte',
  'validation.firstNameRequired': 'O primeiro nome é obrigatório',
  'validation.lastNameRequired': 'O apelido é obrigatório',
  'validation.emailRequired': 'É necessário um e-mail válido',
  'validation.phoneRequired': 'O número de telefone é obrigatório',
  'validation.addressRequired': 'A morada é obrigatória',
  'validation.cityRequired': 'A cidade é obrigatória',
  'validation.countryRequired': 'O país é obrigatório',
  'validation.postalCodeRequired': 'O código postal é obrigatório',
  'error.pmsUnavailable':
    'Lamentamos, mas este quarto já não está disponível para as datas selecionadas. Por favor, volte atrás e escolha outras datas ou outro quarto.',
  'error.pmsSyncError':
    'Não conseguimos ligar ao sistema da propriedade. Por favor, tente novamente dentro de momentos.',
  'error.paymentNotConfigured':
    'O pagamento não está configurado para esta propriedade. Por favor, escolha outra propriedade ou contacte o apoio.',
  'error.paymentStartFailed': 'Algo correu mal ao iniciar o pagamento. Por favor, tente novamente.',
  'error.bookingFailed': 'A reserva falhou. Por favor, tente novamente.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Reserve a sua estadia',
  'site.title.suffix': 'Apartamentos e hotéis',
  'site.title.home': 'Início',
  'site.title.search': 'Pesquisa',
  'site.title.property': 'Propriedade',
  'site.title.room': 'Quarto',
  'site.title.guestDetails': 'Dados do hóspede',
  'site.title.payment': 'Pagamento',
  'site.title.confirmation': 'Reserva confirmada',
  'site.title.bookingLookup': 'Encontre a sua reserva',
  'site.title.bookingDetails': 'Detalhes da reserva',
  'site.title.cancellation': 'Cancelar reserva',
  'site.title.reservationDetail': 'Detalhes da reserva',
  'site.title.signIn': 'Iniciar sessão',
  'site.title.signUp': 'Registar-se',
  'site.title.notFound': 'Página não encontrada',
  'notFound.title': 'Página não encontrada',
  'notFound.message': 'A página que procura não existe.',
  'notFound.backHome': 'Voltar ao início',
  'home.heroAlt': 'Panorama da cidade da Austrália',
  'home.featuredProperties': 'Propriedades em destaque',
  'home.popularDestinations': 'Destinos populares',
  'common.reviews': '{count} avaliações',
  'common.reviews_one': '{count} avaliação',
  'common.reviews_other': '{count} avaliações',
  'common.loading': 'A carregar',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'de',
  'common.select': 'Selecionar…',
  'common.search': 'Pesquisar…',
  'common.selectLocation': 'Selecione uma localização',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'Sem opções disponíveis',
  'common.code': 'Código',
  'common.searchCode': 'Pesquisar código…',
  'filter.title': 'Filtros',
  'filter.price': 'Preço',
  'filter.priceMinimum': 'Mínimo',
  'filter.priceMaximum': 'Máximo',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'Tipo de propriedade',
  'filter.propertyType.hotel': 'Hotel',
  'filter.propertyType.apartment': 'Apartamento',
  'filter.propertyType.resort': 'Resort',
  'filter.amenities': 'Comodidades',
  'filter.amenity.pool': 'Piscina',
  'filter.amenity.parking': 'Estacionamento',
  'filter.amenity.breakfast': 'Pequeno-almoço incluído',
  'filter.rating': 'Classificação',
  'filter.rating.any': 'Qualquer classificação',
  'filter.rating.5': '5 estrelas',
  'filter.rating.4': '4 estrelas ou mais',
  'filter.rating.3': '3 estrelas ou mais',
  'filter.more': 'Mais',
  'filter.more.freeCancellation': 'Cancelamento gratuito',
  'filter.more.payAtProperty': 'Pagar na propriedade',
  'filter.clear': 'Limpar',
  'filter.apply': 'Aplicar filtros',
  'card.reviews_one': 'avaliação',
  'card.reviews_other': 'avaliações',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'Idades 0 - 12',
  'auth.orContinueWith': 'Ou continuar com',
  'auth.signIn.title': 'Inicie sessão na sua conta',
  'auth.signIn.subtitle':
    'Bem-vindo de volta! Inicie sessão para gerir as suas reservas, ver as suas estadias e aceder a ofertas exclusivas.',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'Introduza o seu endereço de e-mail',
  'auth.emailRequired': 'O e-mail é obrigatório.',
  'auth.emailInvalid': 'Por favor, introduza um endereço de e-mail válido.',
  'auth.password': 'Palavra-passe',
  'auth.passwordPlaceholder': 'Introduza a sua palavra-passe',
  'auth.createPasswordPlaceholder': 'Crie uma palavra-passe',
  'auth.passwordRequired': 'A palavra-passe é obrigatória.',
  'auth.passwordMinLength': 'A palavra-passe tem de ter pelo menos {min} caracteres.',
  'auth.passwordPattern': 'A palavra-passe tem de incluir letras e números.',
  'auth.passwordHint':
    'Utilize pelo menos {min} caracteres, com uma combinação de letras, números e símbolos.',
  'auth.showPassword': 'Mostrar palavra-passe',
  'auth.hidePassword': 'Ocultar palavra-passe',
  'auth.keepSignedIn': 'Manter sessão iniciada',
  'auth.forgotPassword': 'Esqueceu-se da palavra-passe?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Iniciar sessão',
  'auth.signingIn': 'A iniciar sessão...',
  'auth.signInError': 'O início de sessão falhou. Por favor, tente novamente.',
  'auth.googleError': 'O início de sessão com Google falhou.',
  'auth.noAccount': 'Ainda não tem conta?',
  'auth.createAccount': 'Criar uma conta',
  'auth.signUp.title': 'Crie a sua conta',
  'auth.signUp.subtitle':
    'Junte-se a {site} para gerir as suas reservas, guardar as suas propriedades favoritas e obter ofertas exclusivas.',
  'auth.firstName': 'Primeiro nome',
  'auth.firstNamePlaceholder': 'Introduza o seu primeiro nome',
  'auth.firstNameRequired': 'O primeiro nome é obrigatório.',
  'auth.lastName': 'Apelido',
  'auth.lastNamePlaceholder': 'Introduza o seu apelido',
  'auth.lastNameRequired': 'O apelido é obrigatório.',
  'auth.mobile': 'Número de telemóvel',
  'auth.mobilePlaceholder': 'Introduza o seu número de telemóvel',
  'auth.dialingCode': 'Indicativo do país',
  'auth.mobileRequired': 'O número de telemóvel é obrigatório.',
  'auth.mobileInvalid': 'Por favor, introduza um número de telemóvel válido.',
  'auth.confirmPassword': 'Confirmar palavra-passe',
  'auth.confirmPasswordPlaceholder': 'Confirme a sua palavra-passe',
  'auth.termsAgree': 'Concordo com os',
  'auth.termsRequired': 'Tem de concordar com os Termos e Condições e a Política de Privacidade.',
  'auth.marketingConsent':
    'Gostaria de receber ofertas exclusivas e inspiração de viagens de {site}',
  'auth.signUpError': 'Não foi possível criar a conta. Por favor, tente novamente.',
  'auth.signUp': 'Registar-se',
  'auth.creatingAccount': 'A criar conta...',
  'auth.createAccountButton': 'Criar conta',
  'auth.alreadyHaveAccount': 'Já tem conta?',
  'auth.passwordMismatch': 'As palavras-passe não coincidem.',
  'pricing.title': 'Resumo de preços',
  'pricing.noRoomsSelected':
    'Nenhum quarto selecionado. Por favor, volte atrás e selecione quartos.',
  'pricing.backToAvailability': 'Voltar à disponibilidade',
  'pricing.continue': 'Continuar para os dados do hóspede',
  'property.youSavePercent': 'Poupa ({percent}% de desconto)',
  'property.includingTaxesFees': '(incl. impostos e taxas)',
  'map.zoomIn': 'Aumentar zoom',
  'map.zoomOut': 'Diminuir zoom',
  'map.viewFullMap': 'Ver em mapa completo',
  'booking.progress': 'Progresso da reserva',
  'reservationDetail.resetAria': 'Repor estado da reserva',
  'bookingLookup.title': 'Encontre a sua reserva',
  'bookingLookup.description':
    'Introduza a referência da reserva e o e-mail para ver, modificar ou cancelar a sua reserva.',
  'bookingLookup.bookingReference': 'Referência da reserva',
  'bookingLookup.placeholder': 'ex.: SYD-260815-0001',
  'bookingLookup.lookingUp': 'A procurar…',
  'bookingLookup.findBooking': 'Encontrar reserva',
  'bookingLookup.notFound':
    'Reserva não encontrada. Tente BK-2026-001, alex.morgan@example.com e Morgan.',
  'cancellation.title': 'Cancelar reserva',
  'cancellation.property': 'Propriedade',
  'cancellation.details': 'Detalhes do cancelamento',
  'cancellation.penalty': 'Penalização de cancelamento',
  'cancellation.refund': 'Montante do reembolso',
  'cancellation.totalPaid': 'Total pago:',
  'cancellation.reasonLabel': 'Motivo do cancelamento (opcional)',
  'cancellation.understand': 'Compreendo que esta ação não pode ser anulada.',
  'cancellation.cancelledDemo':
    'A sua reserva foi cancelada nesta demonstração da interface. Montante do reembolso: {{refundAmount}}.',
  'cancellation.confirm': 'Confirmar cancelamento',
  'cancellation.notFound': 'Reserva não encontrada.',
  'bookingDetails.title': 'Detalhes da reserva',
  'bookingDetails.notFound': 'Reserva não encontrada.',
  'bookingDetails.checkIn': 'Check-in:',
  'bookingDetails.checkOut': 'Check-out:',
  'bookingDetails.rooms': 'Quartos',
  'bookingDetails.guest': 'Hóspede',
  'bookingDetails.freeCancellationUntil': 'Cancelamento gratuito até {date}',
  'bookingDetails.total': 'Total:',
  'reservationDetail.loading': 'A carregar a sua reserva…',
  'reservationDetail.noReference': 'Não foi fornecida nenhuma referência de reserva.',
  'reservationDetail.loadError': 'Não foi possível carregar os detalhes da reserva.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'A carregar localizações…',
  'common.couldNotLoadLocations': 'Não foi possível carregar as localizações',
  'common.searchLocationPlaceholder': 'Pesquisar país, cidade ou propriedade',
  'common.collapse': 'Colapsar',
  'common.expand': 'Expandir',
  'map.loadingGoogle': 'A carregar o Google Map…',
  'map.errorGoogle': 'Não foi possível carregar o Google Maps',
  'map.errorMap': 'Não foi possível carregar o mapa.',
  'map.greatLocation': 'Excelente localização',
  'home.trust.secureBooking': 'Reserva segura',
  'home.trust.secureBookingDesc': 'As suas informações estão seguras connosco.',
  'home.trust.bestPrice': 'Garantia do melhor preço',
  'home.trust.bestPriceDesc': 'Encontrou um preço mais baixo? Vamos igualá-lo.',
  'home.trust.localSupport': 'Apoio 24/7',
  'home.trust.localSupportDesc': 'Estamos aqui para ajudar a qualquer hora.',
  'home.trust.flexibleBooking': 'Opções flexíveis',
  'home.trust.flexibleBookingDesc': 'Cancelamento gratuito em tarifas selecionadas.',
  'promotion.memberPromo': 'Promoção de membro',
  'promotion.save': 'Poupar',
  'property.memberRate': 'Tarifa de membro',
  'property.hideAmenities': 'Ocultar comodidades',
  'property.showAllAmenities': 'Mostrar todas as comodidades',
  'property.chooseRatePromo':
    'Escolha a sua tarifa preferida — as tarifas de membro oferecem poupanças exclusivas!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-{percent}% de desconto',
  'gallery.imageAlt': '{title} vista {current} de {total}',
  'gallery.thumbnailAlt': 'Ir para a vista {current} de {total}',
  'gallery.previewAlt': 'Pré-visualização de {title}',
  'detail.night_one': 'noite',
  'detail.night_other': 'noites',
  'detail.adult_one': 'adulto',
  'detail.adult_other': 'adultos',
  'detail.child_one': 'criança',
  'detail.child_other': 'crianças',
  'detail.infant_one': 'bebé',
  'detail.infant_other': 'bebés',
} as const;
